import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ServiceUsersListPage = lazy(
  () => import('~/features/service-auth/pages/service-users-list-page'),
);

export const Route = createFileRoute('/_authenticated/_tenant/platform/service-auth/users/')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ServiceUsersListPage />
    </Suspense>
  ),
});
